import subject from '../auth';

import Channel from '../utils/channel';
import immortal from '../utils/immortal';
import ws from '../http/ws';

const Hub = new Channel( writeFn => subject
    .then( () => immortal( () => ws( '/news/cache?apiVersion=2.0' ),  
        5, // 5 attempts
        15 * 1000, // in 15 secs each,
        5 * 60 * 1000 // reconnecting in 5 min 
        ) )
    .then( ch => ch.dest( writeFn ) ) )

export default Hub;


// WEBPACK FOOTER //
// ./src/js/service/hub.js